module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921032651_T.7ce1d0dd.jpg";